import { useState, useEffect } from 'react';

/** Match Transfers phone detection: portrait or landscape phone. */
export default function useIsPhone() {
  const [isPhone, setIsPhone] = useState(false);

  useEffect(() => {
    const check = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      const isPhonePortrait = width <= 480;
      const isPhoneLandscape = height <= 480 && width <= 896;
      setIsPhone(isPhonePortrait || isPhoneLandscape);
    };
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  return isPhone;
}
